import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './hotel_v2/Header';
import Footer from './hotel_v2/Footer';
import Home from './hotel_v2/Home';
import Rooms from './hotel_v2/Rooms';
import Spa from './hotel_v2/Spa';
import Reserve from './hotel_v2/Reserve';

export default function HotelTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F5EFDF]" data-testid="aur-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`aur-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'rooms' && <Rooms setPage={setPage} />}
          {page === 'spa' && <Spa setPage={setPage} />}
          {page === 'reserve' && <Reserve setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
